import type { ReactNode } from "react";
import { useState } from "react";
import { TransformRuleType } from "../../types/transformation/TransformationRuleTypes";
import Icon from "../Icon";
import { TransformRuleTypeSelector } from "./TransformRuleTypeSelector";
import "../../styles/transformation/transformationEditorHeader.css";
import { Button } from "../buttons/Button";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { TTTransformAddRule } from "../tooltips/ConfigurationTooltips";

export { TransformationEditorHeader };

type Props = {
  fieldName: string;

  addBlankRule: (ruleType: TransformRuleType) => void;
  /**
   * When Open / Close button pressed
   */
  open?: boolean;
  setOpen: (open: boolean) => void;
  children?: ReactNode;
};

const TransformationEditorHeader = (props: Props) => {
  return (
    <div className={"transformEditorHeader"}>
      {/* Display Field Name */}
      <h3 data-field-name>{props.fieldName}</h3>

      <span className={"fluffer"}></span>

      <Button
        onClick={() => {
          props.setOpen(!props.open);
        }}
      >
        {props.open ? "Close " : "Edit "}
        {props.open ? (
          <Icon altText={"Close Editor"} icon={"times"} />
        ) : (
          <Icon altText={"Open Editor"} icon={"cog"} />
        )}
      </Button>

      {props.children}
    </div>
  );
};
